import { Component } from 'react';
import { NumericFormat } from 'react-number-format';

import isEmpty from 'Lib/utilities/isEmpty';

class Integer extends Component {
    render() {
        const { id, className, style, required, emptyText = '--', prefix, value, defaultValue, renderText = false } = this.props;
        const attrs = {
            id,
            className,
            style,
            required,
            prefix,
            renderText: renderText ? value => value : null,
            decimalScale: 0,
            fixedDecimalScale: true,
            thousandSeparator: ',',
            value: isEmpty(value) ? defaultValue : value
        };

        if (isEmpty(attrs.value)) {
            return <span>{emptyText}</span>;
        }

        return <NumericFormat {...attrs} displayType="text" />;
    }
}

export default Integer;
